import React from 'react';
import { ButtonGroup, Button } from 'react-bootstrap';

// Campos ✓ / ✗ del Seguimiento de Egresados (punto 7 de José, 25/09/2026).
// Tres estados: true = ✓ (sí / aplica), false = ✗ (no / no aplica),
// null = sin dato (todavía no se evaluó).

// Marca de solo lectura para tablas y fichas.
export const MarcaSiNo = ({ valor, si = 'Sí', no = 'No' }) => {
  if (valor === true) {
    return <span title={si} style={{ color: '#198754', fontWeight: 700, fontSize: '1.1rem' }}>✓</span>;
  }
  if (valor === false) {
    return <span title={no} style={{ color: '#dc3545', fontWeight: 700, fontSize: '1.1rem' }}>✗</span>;
  }
  return <span title="Sin dato" className="text-muted">—</span>;
};

// Selector para formularios: ✓ / ✗ / sin dato.
export const SelectorSiNo = ({ valor, onChange, si = 'Sí', no = 'No', disabled = false }) => (
  <ButtonGroup size="sm">
    <Button
      variant={valor === true ? 'success' : 'outline-success'}
      onClick={() => onChange(true)}
      disabled={disabled}
    >
      ✓ {si}
    </Button>
    <Button
      variant={valor === false ? 'danger' : 'outline-danger'}
      onClick={() => onChange(false)}
      disabled={disabled}
    >
      ✗ {no}
    </Button>
    <Button
      variant={valor === null || valor === undefined ? 'secondary' : 'outline-secondary'}
      onClick={() => onChange(null)}
      disabled={disabled}
    >
      Sin dato
    </Button>
  </ButtonGroup>
);
